import { map, unwrap } from "@lvt/web-data";
import { useEffect, useState } from "react";

import { fetchCameraData } from "@/api/cameras";
import { StreamMeta } from "@/api/streamMetadata";
import { fetchUserListsData } from "@/api/users";
import CameraNav from "@/common/components/streaming/CameraNav/CameraNav";
import { RootState, useDispatch, useSelector } from "@/store";
import { CameraNavigation, GroupedCameraNavigation } from "@/store/userLists/types";


export const StreamCamNav: React.FC = () => {
    const user = useSelector((state: RootState) => state.user);
    const selectedCameraId = useSelector((state: RootState) => state.cameras.streamingId);
    const locationId = useSelector((state: RootState) =>
        unwrap(
            map(state.stream.streamMeta, (streamMeta: StreamMeta) => {
                return streamMeta.locationId;
            }),
        ),
    );
    const cameraList = useSelector((state: RootState) => unwrap(state.cameras.cameraList));
    const userPermissions = useSelector((state) => state.user.permissions);

    const dispatch = useDispatch();
    const [groupedCameras, setGroupedCameras] = useState<GroupedCameraNavigation[] | null>(null);


    useEffect(() => {
        if (user && user.id) {
            dispatch(fetchUserListsData(user.id));
        }
    }, [user]);

    useEffect(() => {
        if (selectedCameraId) {
            dispatch(fetchCameraData(selectedCameraId));
        }
    }, [selectedCameraId]);

    useEffect(() => {
        if (locationId && cameraList) {
            const newCamerasObj = cameraList.reduce((cams: Record<number, CameraNavigation[]>, cam) => {
                if (cam.locationId === locationId) {
                    if (cams[cam.liveUnitId]) {
                        cams[cam.liveUnitId].push(cam);
                    } else {
                        cams[cam.liveUnitId] = [cam];
                    }
                }

                return cams;
            }, {});

            const newCamerasList = [];

            for (const [liveUnitId, cameras] of Object.entries(newCamerasObj)) {
                const groupedCams = {
                    liveUnitId: parseInt(liveUnitId),
                    liveUnitName: cameras[0].liveUnitName,
                    cameras,
                };

                newCamerasList.push(groupedCams);
            }

            setGroupedCameras(newCamerasList);
        }
    }, [cameraList, locationId]);

    return (
        <CameraNav
            data-testid="cameraNavigation"
            activeCameraId={selectedCameraId}
            cameras={groupedCameras || undefined}
            streamDeactivated={userPermissions?.streamDeactivated}
        />
    );
};
